import { render, staticRenderFns } from "./U3SearchResult.vue?vue&type=template&id=2176aec5&"
import script from "./U3SearchResult.js?vue&type=script&lang=js&"
export * from "./U3SearchResult.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/frameto/WebSites/U3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2176aec5', component.options)
    } else {
      api.reload('2176aec5', component.options)
    }
    module.hot.accept("./U3SearchResult.vue?vue&type=template&id=2176aec5&", function () {
      api.rerender('2176aec5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/U3SearchResult.vue"
export default component.exports